import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import GoalsBody from './body.tsx';
import GoalsHeader from './header.tsx';

const Goals = () => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!isLoggedIn)
            navigate("/login");
    }, [isLoggedIn, navigate]);

    if (!isLoggedIn)
        return null;

    return (
        <>
            <GoalsHeader />
            <GoalsBody />
        </>
    );
};

export default Goals;
